
import {Link} from 'react-router-dom';
import styled from "styled-components";

const StyledLogo = styled(Link)`
    text-decoration: none;
    font-size: 1.5rem;
    font-weight: 400;
    font-family: 'Lobster Two', cursive;
`;

export default StyledLogo;
